import styled from 'styled-components';
import { Flex, FlexColumn } from '@equifinance/shared';
import { useMemo } from 'react';
import { EquifaxAccordionHeaderShadow } from '../../../Credit/CreditDetails/CreditDetails';
import { AuditRecord, AuditValueType } from '../../../../contexts/audit';

const ExpandableContainer = styled(Flex)`${({ theme }) => `
  gap: ${theme.padding[7]};
  padding: ${theme.padding[5]} ${theme.padding[6]};
  background: ${theme.colours.neutral[9]};
  font-size: ${theme.fontSize[1]};
  position: relative;
  color: ${theme.colours.neutral[2]};
`}`;

const HeaderShadow = styled(EquifaxAccordionHeaderShadow)`${({ theme }) => `
  top: -${theme.padding[1]};
  background: linear-gradient(180deg, ${theme.colours.neutral[7]} 0%, ${theme.colours.neutral[9]} 100%);
  left: 0;
`}`;

const ExpandableBody = styled(Flex)`${({ theme }) => `
  padding: ${theme.padding[5]} 0;
  background: ${theme.colours.neutral[10]};
  border-radius: ${theme.padding[3]};
  width: 100%;
  box-shadow: ${theme.boxShadow[2]};
`}}`;

const AuditRecordValueWrapper = styled(FlexColumn)`${({ theme }) => `
  padding: 0 ${theme.padding[5]};
  gap: ${theme.padding[3]};
  box-sizing: border-box;
  width: 50%;

  &:first-of-type {
    border-right: ${theme.borderWidth[1]} solid ${theme.colours.neutral[7]};
  }
`}`;

const AuditRecordValueHeaderOld = styled.div`${({ theme }) => `
  background: ${theme.colours.neutral[8]};
  padding: ${theme.padding[1]} ${theme.padding[3]};
  border-radius: ${theme.borderRadius[1]};
  font-weight: ${theme.fontWeight.bold};
`}`;

const AuditRecordValueHeaderNew = styled(AuditRecordValueHeaderOld)`${({ theme }) => `
  background: ${theme.colours.tertiary[6]};
`}`;

const AuditRecordValue = styled.p`${({ theme }) => `
  white-space: break-spaces;
  padding: 0 ${theme.padding[3]};
`}`;

function beautifyJSON(value: string): string {
  try {
    let parsed = value.trim();

    while (typeof parsed === 'string') {
      parsed = JSON.parse(parsed);
    }

    return JSON.stringify(parsed, null, 2);
  } catch {
    return value;
  }
}

export default function ExpandableContent({ data }: { data: AuditRecord }) {
  const oldValue = useMemo(() => {
    if (data.oldValue === '' || data.oldValue == null) {
      return '-';
    }
    if (data.valueType === AuditValueType.JSON) {
      return beautifyJSON(data.oldValue);
    }
    return data.oldValue;
  }, [data.valueType, data.oldValue]);

  const newValue = useMemo(() => {
    if (data.newValue === '' || data.newValue == null) {
      return '-';
    }
    if (data.valueType === AuditValueType.JSON) {
      return beautifyJSON(data.newValue);
    }
    return data.newValue;
  }, [data.valueType, data.newValue]);

  return (
    <ExpandableContainer>
      <HeaderShadow />
      <ExpandableBody>
        <AuditRecordValueWrapper>
          <AuditRecordValueHeaderOld>
            OLD VALUE
          </AuditRecordValueHeaderOld>
          <AuditRecordValue>
            {oldValue}
          </AuditRecordValue>
        </AuditRecordValueWrapper>
        <AuditRecordValueWrapper>
          <AuditRecordValueHeaderNew>
            NEW VALUE
          </AuditRecordValueHeaderNew>
          <AuditRecordValue>
            {newValue}
          </AuditRecordValue>
        </AuditRecordValueWrapper>
      </ExpandableBody>
    </ExpandableContainer>
  );
}
